import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../src/environments/env';
import Utils from 'src/app/utils/utils';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {

  constructor(private http: HttpClient, private utils: Utils) { }

  private apiUrl = environment.BASE_URL + `/ptp/`;
  public header = { headers: { 'Access-Control-Allow-Origin': '*' } }

  getISCPStatus(userId: string): Observable<any> {
    return this.http.get<any[]>(this.apiUrl + `api/admin/training-status/users/${userId}/iscp-status`, this.header);
  }

  public reviewISCP(providrCode: any, referCode: any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/mct/api/check-iscp?iscpproviderCode=${providrCode}&iscpreferCode=${referCode}`, this.header);
  }

  public reviewMsLearn() {
    return this.http.get<any[]>(this.apiUrl + `api/spp/mct/api/credentials`, this.header);
  }

  public fetchadminData(page: any, size: any, filterString: any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/admin/user?view=admin&page=` + page + `&size=` + size + filterString, this.header);
  }

  public fetchuserData(page: any, size: any, filterString: any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/admin/user?view=active&page=` + page + `&size=` + size + filterString, this.header);
  }

  public fetchexpireData(page: any, size: any, filterString: any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/admin/user?view=expired&page=` + page + `&size=` + size + filterString, this.header);
  }

  public fetchsuspendData(page: any, size: any, filterString: any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/admin/user?view=suspend&page=` + page + `&size=` + size + filterString, this.header);
  }

   public fetchinstructorData(page: any, size: any, filterString: any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/admin/user?view=active&page=` + page + `&size=` + size + filterString, this.header);
  }

  public onPassFailAction(payload: any): Observable<any[]> {
    // return this.http.put<any[]>(this.apiUrl + `api/admin/training/update-result?status=${payload.status}&email=${payload.email}&trainingType=ILT`, this.header);
    return this.http.put<any[]>(this.apiUrl + `api/admin/training/update-result?status=${payload.status}&email=${payload.email}`, this.header);
  }


 public fetchUserData(page: any, size: any, filterString: any, sort: any): Observable<any[]> {    
    const params = this.utils.buildHttpParams({
      view: 'ilt',
      page: page,
      size: size,
      filterString: filterString,
      sort: sort
    });

    const url = this.apiUrl + 'api/admin/user';

    return this.http.get<any[]>(url, { 
      ...this.header, 
      params: params 
    });
  }

  public fetchRenewalData(page: any, size: any, filterString: any, sort: any): Observable<any[]> {

    const params = this.utils.buildHttpParams({
      view: 'renewal',
      page: page,
      size: size,
      filterString: filterString,
      sort: sort
    });

    const url = this.apiUrl + 'api/admin/user';

    return this.http.get<any[]>(url, { 
      ...this.header, 
      params: params 
    });

  }

   public fetchExpiredData(page: any, size: any, filterString: any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/admin/user?view=expired&page=` + page + `&size=` + size + filterString, this.header);
  }

  public viewUserData(id: any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/admin/user/` + id);
  }

   public viewMTMData(id: any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/admin/mtm/history?email=` + id);
  }

  public addNewUser(payload: any): Observable<any[]> {
    return this.http.post<any[]>(this.apiUrl + `api/admin/user`, payload, this.header);
  }

  public editUserData(id: any, payload: any): Observable<any[]> {
    return this.http.put<any[]>(this.apiUrl + `api/admin/user/` + id, payload, this.header);
  }

  public removeUserData(id: any): Observable<any[]> {
    return this.http.delete<any[]>(this.apiUrl + `api/admin/user/` + id);
  }

  public suspendUser(id: any, remarks: any): Observable<any[]> {
    return this.http.put<any[]>(this.apiUrl + `api/spp/mct/` + id + `/status/suspend?status=SUSPEND&remarks=` + remarks, this.header);
  }

   public instructorUser(id: any): Observable<any[]> {
    return this.http.put<any[]>(this.apiUrl + `api/admin/instructor/` + id + `/active/instructor`, this.header);
  }

  public revokeInstructor(id: any): Observable<any[]> {
    return this.http.put<any[]>(this.apiUrl + `api/admin/instructor/` + id + `/instructor/active`, this.header);
  }

  public revokeUser(id: any, remarks: any): Observable<any[]> {
    return this.http.put<any[]>(this.apiUrl + `api/spp/mct/` + id + `/status/suspendToActive?status=ACTIVE_MCT&remarks=` + remarks, this.header);
  }



  public fetchUserType(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/admin/user-types/selectList`);
  }

  public uploadFile(file: any): Observable<any[]> {
    return this.http.post<any[]>(this.apiUrl + `api/admin/user/upload`, file);
  }

  public fetchuserHistory(id:any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/mct-users-history/user/${id}`);
  }


  public fetchMonthlyReportData(year: any, month: any, page: any, size: any, sort: any, typeOfReport: any): Observable<any[]> {
    const params = this.utils.buildHttpParams({
      page: page,
      size: size,
      sort: sort,
    });

     const url =  this.apiUrl + `api/admin/mct/report/list?year=` + year + `&month=` + month + `&group=` + typeOfReport;
     return this.http.get<any[]>(url, { 
      ...this.header, 
      params: params 
    });
  }

  public fetchReportDashboardData(year: any, month: any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/admin/mct/report/dashboardReport?month=${month}&year=${year}`, this.header);
  }
      

}
